import api from "./client";

/**
 * Create a new abandoned vehicle record
 * Note: Uses skipAutoLogout to prevent logout on auth errors since this is a non-critical operation
 */
export const createAbandonedVehicle = async (data) => {
  const response = await api.post("/abandonedvehicles", data, { skipAutoLogout: true });
  return response.data;
};

/**
 * Get abandoned vehicles near a location
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {number} radiusMeters - Optional radius in meters (default: 402.336 = 0.25 miles)
 * Note: Uses skipAutoLogout to prevent logout on auth errors since this runs in background
 */
export const getAbandonedVehiclesNearby = async (lat, lng, radiusMeters = null) => {
  const params = { lat, lng };
  if (radiusMeters) {
    params.radiusMeters = radiusMeters;
  }
  const response = await api.get("/abandonedvehicles/nearby", { params, skipAutoLogout: true });
  return response.data;
};

/**
 * Get all active abandoned vehicles
 */
export const getActiveAbandonedVehicles = async () => {
  const response = await api.get("/abandonedvehicles/active");
  return response.data;
};

/**
 * Get a specific abandoned vehicle by ID
 */
export const getAbandonedVehicleById = async (id) => {
  const response = await api.get(`/abandonedvehicles/${id}`);
  return response.data;
};

/**
 * Mark an abandoned vehicle as "STILL THERE" - extends expiration by 5 days
 * Note: Uses skipAutoLogout to prevent logout on auth errors
 */
export const markAbandonedVehicleStillThere = async (id) => {
  const response = await api.put(`/abandonedvehicles/${id}/still-there`, {}, { skipAutoLogout: true });
  return response.data;
};

/**
 * Mark an abandoned vehicle as "UTL" (Unable To Locate) - clears from database
 * Note: Uses skipAutoLogout to prevent logout on auth errors
 */
export const markAbandonedVehicleUtl = async (id) => {
  const response = await api.put(`/abandonedvehicles/${id}/utl`, {}, { skipAutoLogout: true });
  return response.data;
};

/**
 * Get history of cleared/expired abandoned vehicles
 */
export const getAbandonedVehicleHistory = async (days = 30) => {
  const response = await api.get("/abandonedvehicles/history", { params: { days } });
  return response.data;
};

export default {
  createAbandonedVehicle,
  getAbandonedVehiclesNearby,
  getActiveAbandonedVehicles,
  getAbandonedVehicleById,
  markAbandonedVehicleStillThere,
  markAbandonedVehicleUtl,
  getAbandonedVehicleHistory,
};
